import { useEffect, useState, useRef, useContext } from "react";

import { Button, Box, Typography } from "@mui/material";

import { config } from "./Config";
import { Trans } from "./Translations";

export default function ContactButton(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { _ } = useContext(Trans);
  return (
    <Box
      sx={{
        boxShadow: 5,
        position: "fixed",
        bottom: 0,
        right: 0,
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "@media (orientation: landscape)": {
          width: {
            xs: "250px",
            lg: "350px",
            xl: "500px",
          },
          height: {
            xs: "50px",
            xl: "95px",
          },
        },
        "@media (orientation: portrait)": {
          width: "100%",
          height: "50px",
        },
      }}
    >
      <Button
        onClick={async () => {
          props.setOpen(!props.open);
        }}
        sx={{
          "::after": {
            content: '""',
            marginLeft: "10px",
            width: "20px",
            height: "20px",
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg id='bag' xmlns='http://www.w3.org/2000/svg' width='19.809' height='20' viewBox='0 0 19.809 20'%3E%3Cpath id='rect1979' d='M11.9,292.65a4.013,4.013,0,0,0-4,4v1H3a1,1,0,0,0-1,1v10a4.013,4.013,0,0,0,4,4H17.809a4.013,4.013,0,0,0,4-4v-10a1,1,0,0,0-1-1H15.9v-1A4.013,4.013,0,0,0,11.9,292.65Zm0,2a1.974,1.974,0,0,1,2,2v1h-4v-1A1.974,1.974,0,0,1,11.9,294.65Zm-7.9,5H7.9v2.979a1,1,0,0,0,2,0V299.65h4v2.979a1,1,0,0,0,2,0V299.65h3.9v9a1.974,1.974,0,0,1-2,2H6a1.974,1.974,0,0,1-2-2Z' transform='translate(-2 -292.65)' fill='%23fff' /%3E%3C/svg%3E\")",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "50% 50%",
          },
          ":hover": {
            backgroundColor: "#000",
          },
          margin: "0 15px",
          minWidth: "90%",
          color: "white",
          backgroundColor: "#a21318",
          fontWeight: "bold",
          border: "none",
          borderRadius: "7px",
          textTransform: "uppercase",
          transition: "all 0.3s",
          fontFamily: '"Montserrat", sans-serif',
          "@media (orientation: landscape)": {
            xs: {
              height: "40px",
              fontSize: "10px",
            },
            xl: {
              height: "60px",
              padding: "20px",
              fontSize: "14px",
            },
          },
          "@media (orientation: portrait)": {
            height: "40px",
            fontSize: "10px",
          },
        }}
      >
        {_("Send enquiry")}
      </Button>
    </Box>
  );
}
